<template>
	<div>
		<div class="has-text-centered mt100">
			<a rel="noreferrer" href="#" class="button btn-warning hvr-shutter-out-vertical hvr-primary is-rounded p25" @click.prevent="controlModal=true">{{t('book_now')}}</a>
		</div>
		<div class="modal" :class="{ 'is-active': controlModal}">
			<div class="modal-background is-white"></div>
			<div class="card modal-content">
				<div class="has-text-centered overflow-hidden">
					<div class="has-background-warning has-text-white has-text-weight-bold p5">
						<p class="has-text-centered is-size-6">
							{{t('book_now')}}
						</p>
					</div>
					<div class="p30">
						<div class="field mb30">
							<div class="control">
								<div v-if="userObject" class="input line-input is-primary has-text-centered has-text-grey">
									<span class="is-inline-block mr-auto">{{userObject.name}}</span>
								</div>
								<div v-else>
									<input name="name" class="input line-input is-primary has-text-centered" required autocomplete="name" v-model="form.name" v-validate="{ required: true , alpha_spaces:true }" :class="{'is-danger': errors.has('name') }" type="text" :placeholder="t('name')" >
									<div v-show="errors.has('name')" class="help is-danger has-text-centered">{{ errors.first('name') }}</div>
								</div>
							</div>
						</div>
						<div class="field mb30">
							<div class="control">
								<div v-if="userObject" class="input line-input is-primary has-text-centered has-text-grey">
									<span class="is-inline-block mr-auto">{{userObject.email}}</span>
								</div>
								<div v-else>
									<input name="email" class="input line-input is-primary has-text-centered" required autocomplete="email" v-model="form.email" v-validate="{ required: true , email:true }" :class="{'is-danger': errors.has('email') }" type="text" :placeholder="t('email')" >
									<div v-show="errors.has('email')" class="help is-danger has-text-centered">{{ errors.first('email') }}</div>
								</div>
							</div>
						</div>
						<div class="field mb30">
							<div class="control">
								<div v-if="userObject" class="input line-input is-primary has-text-centered has-text-grey">
									<span class="is-inline-block mr-auto">{{userObject.phone}}</span>
								</div>
								<div v-else>
									<input name="phone" class="input line-input is-primary has-text-centered" required autocomplete="phone" v-model="form.phone" v-validate="{ required: true , digits:11 }" :class="{'is-danger': errors.has('phone') }" type="text" :placeholder="t('phone')" >
									<div v-show="errors.has('phone')" class="help is-danger has-text-centered">{{ errors.first('phone') }}</div>
								</div>
							</div>
						</div>
						<div class="field mb30">
							<div class="control is-expanded">
								<input name="place" class="input line-input is-primary has-text-centered" required autocomplete="place" v-model="form.place" v-validate="{ required: true }" :class="{'is-danger': errors.has('place') }" type="text" :placeholder="t('reserv_address')" >
								<div v-show="errors.has('address')" class="help is-danger has-text-centered">{{ errors.first('place') }}</div>
							</div>
						</div>
						<div class="field mb30">
							<div class="control is-expanded">
								<textarea name="place" class="textarea line-input is-primary has-text-centered"  autocomplete="notes" v-model="form.notes" :placeholder="t('note')" ></textarea>
							</div>
						</div>
						<div class="field mt90">
							<div class="control has-text-centered">
								<button type="submit" class="button btn-warning hvr-shutter-out-vertical hvr-primary is-rounded pr20 pl20" @click.prevent="validateForm">{{t('book_now')}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<button class="modal-close is-large has-background-warning" aria-label="close" @click.prevent="controlModal=false"></button>
		</div>
	</div>
</template>
<script>
import axios from 'axios';
import arabic from 'vee-validate/dist/locale/ar';
import { Validator , mapFields} from 'vee-validate';
import trans from "./translation/user.json";
export default {
	name: "BookNow",
	props: {
		sitelocale:{
			type: String,
			required: true
		},
		userObject:{
			required: true
		},
		action:{
			type: String,
			required: true
		},
        project_id:{
            required: true
        }
	},
	locales: trans,
	data: () => ({
		controlModal:false,
		form:{
			name: '',
			email:'',
			phone: '',
			place: '',
            project_id:null,
			user_id:null,
			notes:null
		},
	}),
	mounted() {
		this.$translate.setLang(this.sitelocale);
	},
	created() {
		if(this.userObject){
			this.form.user_id = this.userObject.id;
		}
		this.form.project_id = this.project_id;

		this.$validator.localize('ar', {
			messages: arabic.messages,
			attributes: trans.ar,
		});
		this.$validator.localize('en', {
			attributes: trans.en,
		});
		Validator.localize(this.sitelocale);
	},
	methods: {
		validateForm(){
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.controlModal=false
					const action = this.action;
					axios.post(action, this.form)
					.then(response => {
						this.showAlert('success' , response.data.message  , '' , '')
					})
					.catch(error => {
						this.showAlert('error',
							`${this.$translate.text('error_in_data')}`,
							'text',
							`<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error[0]}</li>`).join(' ')+`</ul>`
							)
						this.isDisabled=false;
						console.clear();
					})
					.then(()=>{
						setTimeout(()=>{

						}, 3500);
					});
				}
			});
		},
		showAlert(type , title , text , html){
			this.$swal({
				type: type,
				title: title,
				text: text,
				html: html,
				showConfirmButton: false,
				timer:4000,
				customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
				backdrop: `
				rgba(36, 140, 204, 0.5)
				`
			});
		}
	},

};
</script>
